import { render, staticRenderFns } from "./QuotaSpec.vue?vue&type=template&id=320eb2af&"
import script from "./QuotaSpec.vue?vue&type=script&lang=js&"
export * from "./QuotaSpec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports